import { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { useTranslation } from "react-i18next";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { clinicianLogout } from "../../redux/clinicianDucks";
import { clearDismissedNotifications } from "../../redux/recsysDucks";
// Constants - Functions
import { pathHomePage } from "../../config/constants";
import { renderToolTip } from "../../config/functions";
import { isAISNProjectHospital } from "../../config/projectFunctions";
// Components
import {
  HeaderContainer,
  Menu,
  BtnShowMenu,
  BtnShowMenuResponsive,
  CloseImg,
  ResponsiveMenu,
  ResponsiveNavigation,
  RespBtnLogout,
  Navigation,
  ShowHospitalDiv,
  HospitalText,
  ClinicianText,
  ClinicalInvestigationContainer,
  ClinicalInvestigationText,
  LngLogoutContainer,
  BtnLogout,
} from "./styles";
import Translations from "../translations";
import ButtonWithIcon from "../buttonWithIcon";
import ProjectVersion from "../projectVersion";
// Assets
import btnClose from "../../assets/icons/btn_close.svg";
import IcoAvatar from "../../assets/icons/ico_link_avatar.svg";
import IcoSupport from "../../assets/icons/ico_link_support.svg";
import IcoSettings from "../../assets/icons/ico_link_settings.svg";

const Header = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [isAISNHospital, setIsAISNHospital] = useState(false);

  const [t] = useTranslation("global");
  const dispatch = useDispatch();
  const clinicianData = useSelector(({ clinician }) => clinician.data);
  const hospitalName = clinicianData.HOSPITAL_NAME;

  // Set AISN project flag
  useEffect(() => {
    const handleSetAISNProject = async () => {
      const isAISNHospital = await isAISNProjectHospital(hospitalName);
      setIsAISNHospital(isAISNHospital);
    };
    handleSetAISNProject();

    return () => {
      setIsAISNHospital(false);
    };
  }, [hospitalName]);

  const handleRenderLinks = () => {
    return (
      <>
        <ButtonWithIcon
          icon={IcoAvatar}
          name={t("patients")}
          path={`${pathHomePage}/home/${clinicianData.token}`}
          margin="0 5px 0 0"
          width910="170px"
        />
        <ButtonWithIcon
          icon={IcoSupport}
          name={t("header_ContactButton")}
          path={`${pathHomePage}/support/${clinicianData.token}`}
          margin="0 5px 0 0"
          width910="170px"
        />
        <ButtonWithIcon
          icon={IcoSettings}
          name={t("settings")}
          path={`${pathHomePage}/settings/${clinicianData.token}`}
          margin="0 5px 0 0"
          width910="170px"
        />
      </>
    );
  };

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(clinicianLogout());
    dispatch(clearDismissedNotifications());
    setRedirect(true);
  };

  if (redirect) {
    return <Redirect to={`${pathHomePage}`} />;
  }

  const handleShowMenu = (e) => {
    e.preventDefault();
    setShowMenu(!showMenu);
  };

  return (
    <HeaderContainer>
      {isAISNHospital && (
        <ClinicalInvestigationContainer>
          <ClinicalInvestigationText>
            {t("header_clinicalInvestigation")}
          </ClinicalInvestigationText>
        </ClinicalInvestigationContainer>
      )}

      <Menu>
        <BtnShowMenu onClick={handleShowMenu} />

        {showMenu && (
          <ResponsiveMenu>
            <BtnShowMenuResponsive onClick={handleShowMenu}>
              <CloseImg src={btnClose} alt="close-btn" />
            </BtnShowMenuResponsive>

            <ShowHospitalDiv active>
              <HospitalText>{hospitalName}</HospitalText>
            </ShowHospitalDiv>

            <ResponsiveNavigation>
              {handleRenderLinks()}
              <RespBtnLogout onClick={handleLogout}>
                {t("header_logoutButton")}
              </RespBtnLogout>
            </ResponsiveNavigation>
          </ResponsiveMenu>
        )}

        <Navigation>
          {handleRenderLinks()}

          <ShowHospitalDiv>
            <HospitalText data-for="hospitalName" data-tip={hospitalName}>
              {hospitalName}
            </HospitalText>

            {hospitalName?.length > 30 && renderToolTip("hospitalName")}

            <ClinicianText>{clinicianData.CLINICIAN_USER}</ClinicianText>
          </ShowHospitalDiv>
        </Navigation>
        <LngLogoutContainer>
          <Translations />
          <BtnLogout onClick={handleLogout}>
            {t("header_logoutButton")}
          </BtnLogout>
        </LngLogoutContainer>
      </Menu>

      <ProjectVersion />
    </HeaderContainer>
  );
};

export default Header;